<template>
    <div ref="menu" v-if="pageUser != null && pageDefaults != null && pageUser.filters != null">
        <button class="flex items-center justify-between px-0 lg:px-6 w-full pt-4 pb-0 lg:pb-4" @click="toggle">
            <div class="flex items-start">
                <IconFilters class="w-4.5 h-4.5 lg:w-5 lg:h-5 stroke-black dark:stroke-white shrink-0" />

                <p class="text-15 text-grey-900 pl-2 pr-6 text-left hidden lg:block">
                    Displaying
                    <b class="text-black dark:text-white font-semibold">{{ selectedActivity }}</b>
                    by
                    <b class="text-black dark:text-white font-semibold">{{ selectedUsers }}</b>
                    from
                    <b class="text-black dark:text-white font-semibold">{{ selectedDateRange }}</b>
                </p>

                <p class="text-15 text-grey-900 pl-2 block lg:hidden">Filters</p>
            </div>

            <div class="w-10 h-12 flex items-center justify-center shrink-0">
                <IconArrowDown :class="{ 'rotate-180': open }" class="h-4.5 w-4.5 icon-hover transition-all duration-300 shrink-0" />
            </div>
        </button>

        <div class="bg-black">
            <TransitionHeight :visable="open">
                <label class="px-6 pt-6 pb-2 flex items-center cursor-pointer">
                    <InputCheckbox
                        :checked="selectedActivity == 'All activity'"
                        class="flex items-center"
                        @click="
                            () => {
                                if (
                                    _filters.activity.length ===
                                    Object.keys(pageDefaults.filters.find((f) => f.name === 'activity').values).length
                                ) {
                                    _filters.activity = []
                                } else {
                                    _filters.activity = Object.keys(pageDefaults.filters.find((f) => f.name === 'activity').values)
                                }
                            }
                        "
                    />
                    <p class="text-white font-semibold pl-2 text-16">Activities</p>
                </label>

                <div class="grid grid-cols-2 lg:grid-cols-3 text-grey-700 gap-3 px-6 pb-6 text-14 py-2">
                    <label
                        v-for="val in activityFilters"
                        class="flex items-center cursor-pointer"
                    >
                        <input v-model="_filters.activity" :value="parseInt(val[0])" class="input-checkbox" type="checkbox" />

                        <p :class="[_filters.activity.find((f) => f == parseInt(val[0])) ? 'text-white' : '']" class="pl-2">
                            {{ val[1] }}
                        </p>
                    </label>
                </div>

                <label class="px-6 pt-6 pb-2 flex items-center cursor-pointer border-t border-grey-800/40">
                    <InputCheckbox
                        :checked="
                            _filters.activity_details.length ===
                            Object.keys(pageDefaults.filters.find((f) => f.name === 'activity_details').values).length
                        "
                        class="flex items-center"
                        @click="
                            () => {
                                if (
                                    _filters.activity_details.length ===
                                    Object.keys(pageDefaults.filters.find((f) => f.name === 'activity_details').values).length
                                ) {
                                    _filters.activity_details = []
                                } else {
                                    _filters.activity_details = Object.keys(
                                        pageDefaults.filters.find((f) => f.name === 'activity_details').values,
                                    )
                                }
                            }
                        "
                    />
                    <p class="text-white font-semibold pl-2 text-16">Activity details</p>
                </label>

                <div class="grid grid-cols-2 lg:grid-cols-3 text-grey-700 gap-3 px-6 text-14 pb-6 pt-2">
                    <label
                        v-for="(name, key) in pageDefaults.filters.find((f) => f.name == 'activity_details').values"
                        class="flex items-center cursor-pointer"
                    >
                        <input v-model="_filters.activity_details" :value="key" class="input-checkbox" type="checkbox" />

                        <p :class="[_filters.activity_details.indexOf(key) >= 0 ? 'text-white' : '']" class="pl-2">
                            {{ name }}
                        </p>
                    </label>
                </div>

                <div
                    class="px-6 pt-6 pb-2 flex items-center border-t border-grey-800/40 cursor-pointer"
                    @click="
                        () => {
                            if (
                                _filters.created_by.length ===
                                Object.keys(pageDefaults.filters.find((f) => f.name === 'created_by').values).length
                            ) {
                                _filters.created_by = []
                            } else {
                                _filters.created_by = Object.keys(pageDefaults.filters.find((f) => f.name === 'created_by').values)
                            }
                        }
                    "
                >
                    <InputCheckbox
                        :checked="
                            _filters.created_by.length ===
                            Object.keys(pageDefaults.filters.find((f) => f.name === 'created_by').values).length
                        "
                        class="flex items-center"
                    />
                    <p class="text-white font-semibold pl-2 text-16">People</p>
                </div>

                <div class="grid grid-cols-2 lg:grid-cols-3 text-grey-700 gap-3 px-6 text-14 pb-6 pt-2">
                    <label
                        v-for="(name, key) in pageDefaults.filters.find((f) => f.name == 'created_by').values"
                        class="flex items-center cursor-pointer"
                    >
                        <!-- <input type='checkbox' class='input-checkbox'
							:value='key' :checked='_filters.created_by != undefined && _filters.created_by.indexOf(parseInt(key)) > 0'
							@change='updateCreatedBy'
						/> -->

                        <input v-model="_filters.created_by" :value="parseInt(key)" class="input-checkbox" type="checkbox" />

                        <p :class="[_filters.created_by.indexOf(parseInt(key)) >= 0 ? 'text-white' : '']" class="pl-2">
                            {{ name }}
                        </p>
                    </label>
                </div>

                <div
                    class="px-6 pt-6 pb-4 flex items-center border-t border-grey-800/40 cursor-pointer"
                    @click="
                        () => {
                            _filters.date_range[0] = _filters.date_range[0] == 'all time' ? 'date range' : 'all time'

                            if (_filters.date_range[0] == 'date range') {
                                this.setDateRange()
                            }
                        }
                    "
                >
                    <InputCheckbox :checked="_filters.date_range[0] != 'all time'" class="flex items-center" />
                    <p class="text-white font-semibold pl-2 text-16">Period</p>
                </div>

                <!--				<div-->
                <!--					class="grid grid-cols-2 lg:grid-cols-1 text-grey-700 gap-3 px-6 text-14 pb-4 pt-2"-->
                <!--				>-->
                <!--					<label class="flex items-center cursor-pointer">-->
                <!--						<input-->
                <!--							v-model="_filters.date_range[0]"-->
                <!--							:value="'all time'"-->
                <!--							class="input-radio"-->
                <!--							name="date_range"-->
                <!--							type="radio"-->
                <!--						/>-->
                <!--						<p-->
                <!--							:class="[-->
                <!--								_filters.date_range[0] == 'all time'-->
                <!--									? 'text-white'-->
                <!--									: '',-->
                <!--							]"-->
                <!--							class="pl-2"-->
                <!--						>-->
                <!--							All time-->
                <!--						</p>-->
                <!--					</label>-->

                <!--					<label class="flex items-center cursor-pointer">-->
                <!--						<input-->
                <!--							v-model="_filters.date_range[0]"-->
                <!--							:value="'date range'"-->
                <!--							class="input-radio"-->
                <!--							name="date_range"-->
                <!--							type="radio"-->
                <!--							@change="-->
                <!--								() => {-->
                <!--									this.setDateRange();-->
                <!--								}-->
                <!--							"-->
                <!--						/>-->
                <!--						<p-->
                <!--							:class="[-->
                <!--								_filters.date_range[0] == 'date range'-->
                <!--									? 'text-white'-->
                <!--									: '',-->
                <!--							]"-->
                <!--							class="pl-2"-->
                <!--						>-->
                <!--							Date range-->
                <!--						</p>-->
                <!--					</label>-->
                <!--				</div>-->

                <TransitionHeight :visable="_filters.date_range[0] == 'date range'">
                    <div class="relative px-6 grid lg:grid-cols-2 gap-3 pb-6">
                        <InputDropdownDatePicker
                            :apply="false"
                            :value="$moment(from).format('DD/MM/YYYY')"
                            class="col-span-1"
                            inputClass="!h-12"
                            label="Start"
                            name="from"
                            placeholder="DD/MM/YYYY"
                            :dark="true"
                            @change="updateDateRange($event, 0)"
                        />

                        <InputDropdownDatePicker
                            :apply="false"
                            :dark="true"
                            :value="$moment(to).format('DD/MM/YYYY')"
                            class="col-span-1"
                            inputClass="!h-12"
                            label="End"
                            name="to"
                            placeholder="DD/MM/YYYY"
                            @change="updateDateRange($event, 1)"
                        />

                        <!-- <DateInput
							:dark="true"
							:disabled="_filters.date_range[0] != 'date range'"
							:time="false"
							:value="from"
							class="relative"
							label="Start"
							name="from"
							@update:value="updateDateRange($event, 0)"
						/>

						<DateInput
							:dark="true"
							:disabled="_filters.date_range[0] != 'date range'"
							:time="false"
							:value="to"
							class="relative"
							label="End"
							name="to"
							@update:value="updateDateRange($event, 1)"
						/> -->
                    </div>
                </TransitionHeight>

                <div class="grid grid-cols-2 gap-3 px-6 pb-7 pt-4">
                    <button class="h-12 font-semibold text-15 bg-white text-black hover:bg-grey-500" @click="save">Show results</button>

                    <button
                        class="h-12 font-semibold text-15 bg-black border border-white text-white hover:bg-white hover:text-black"
                        @click="cancel"
                    >
                        Cancel
                    </button>
                </div>
            </TransitionHeight>
        </div>
    </div>
</template>

<script>
import { onClickOutside } from '@vueuse/core'

export default {
    props: {
        pageDefaults: [Array, Object],
        pageUser: [Array, Object],
        page: Object,
        type: String
    },

    data() {
        return {
            open: false,
            from: null,
            to: null,
            createdBy: [],
            _filters: null,
        }
    },

    mounted() {
        onClickOutside(this.$refs.menu, (event) => {
            if (this.open) {
                this.open = false
            }
        })
    },

    created() {
        this._filters = Object.assign({}, this.pageUser.filters)
        this.setDateRange()
    },

    methods: {
        toggle() {
            this.open = !this.open
        },

        save() {
            this.page.set('page', 1)
            this.$emit('pageUpdate', this._filters)
            this.setDateRange()
            this.open = false
        },

        cancel() {
            this._filters = Object.assign({}, this.pageUser.filters)
            this.setDateRange()
            this.open = false
        },

        setDateRange() {
            let user = this.$authSanctum.getUser()

            if (this.pageUser != null && this.pageUser.filters != null && this.pageUser.filters.date_range[1] != null) {
                this.from = this.pageUser.filters.date_range[1][0]
                this.to = this.pageUser.filters.date_range[1][1]
            } else {
                this.from = user.created_at

                if (this.$moment(user.created_at).isBefore(this.$moment().subtract(1, 'month'))) {
                    this.from = this.$moment().subtract(1, 'month')
                }

                this.to = this.$moment().format()
            }
        },

        updateCreatedBy(event) {
            let value = parseInt(event.target.value)
            let index = this.createdBy.indexOf(value)

            if (index >= 0) {
                this.createdBy.splice(index, 1)
            } else {
                this.createdBy.push(value)
            }

            this._filters.created_by = this.createdBy
        },

        updateDateRange(value, index) {
            // console.log(this.$moment(value, 'DD/MM/YYYY').format(), index);

            if (this._filters.date_range[1] == null) {
                this._filters.date_range[1] = [this.from, this.to]
            }

            this._filters.date_range[1][index] = this.$moment(value, 'DD/MM/YYYY').format()
        },
    },

    computed: {
        selectedActivity() {
            let activities = this.pageDefaults.filters.find((f) => f.name == 'activity').values

            if (this.pageUser.filters.activity.length == Object.keys(activities).length) {
                return 'All activity'
            }

            let string = []

            for (let i in this.pageUser.filters.activity) {
                string.push(activities[this.pageUser.filters.activity[i]])
            }

            return string.join(', ')
        },

        selectedUsers() {
            let users = this.pageDefaults.filters.find((f) => f.name == 'created_by').values

            let filtersNull = this.pageUser.filters.created_by == null
            let allFiltersSelected = !filtersNull && this.pageUser.filters.created_by.length == Object.keys(users).length
            let noFiltersSelected = !filtersNull && this.pageUser.filters.created_by.length == 0

            if (filtersNull || noFiltersSelected || allFiltersSelected) {
                // allFiltersSelected
                return 'Everyone'
            }

            let string = []

            for (let i in this.pageUser.filters.created_by) {
                string.push(users[this.pageUser.filters.created_by[i]])
            }

            return string.join(', ')
        },

        selectedDateRange() {
            if (this.pageUser.filters.date_range[0] == 'date range') {
                return '' + this.$moment(this.from).format('Do MMMM YYYY') + ' to ' + this.$moment(this.to).format('Do MMMM YYYY')

                // return 'date range from '
                // 	+ this.$moment(this.pageUser.filters.date_range[1][0]).format('Do MMMM YYYY')
                // 	+ " to "
                // 	+ this.$moment(this.pageUser.filters.date_range[1][1]).format('Do MMMM YYYY')
            }

            return this.$help.capitalizeFirstLetter(this.pageUser.filters.date_range[0])
        },

        activityFilters() {
            let order = [];

            switch (parseInt(this.type)) {
                case 102:
                    order = ['Leads', 'Calls', 'Forms', 'Contact', 'Deals', 'Files', 'Tasks', 'Events', 'Notes', 'SMS', 'Email'];
                break;
                case 103:
                    order = ['Leads', 'Calls', 'Forms', 'Contact', 'Files', 'Tasks', 'Events', 'Notes', 'SMS', 'Email'];
                break;
                case 2:
                    order = ['Deals', 'Contact', 'Files', 'Tasks', 'Events', 'Notes', 'SMS', 'Email', 'Leads'];
                break;
            }

            const activities = this.pageDefaults.filters.find((f) => f.name == 'activity').values

            let temp = [];
            for (let i in order) {
                for (let j in activities) {
                    if (order[i] == activities[j]) {
                        temp.push([j, order[i]])
                        break;
                    }
                } 
            }

            console.log(temp)

            return temp;
        },
    },
}
</script>
